import React from 'react';
import styled from 'styled-components';
import { textSize, Points, marginLevel, paddingLevel } from '@styles';
import { getImage } from 'planoplan-ui-kit/core/get_image';
import { Button } from 'planoplan-ui-kit/core/button';
import { deviceDetected } from 'planoplan-ui-kit/core/device-detected';
import { useMediaQuery } from 'planoplan-ui-kit/core/hooks/useMediaQuery';
import { CustomLink } from '@components/Custom-Link';
import { useTranslations } from '@libs/translations';
import { HELP_CENTER } from '@constants';

export const ErrorContent = ({ error, locale }) => {
  const isTabletPortrait = useMediaQuery(Points.tablet_portrait, { useSSR: true });
  const translations = useTranslations();

  return (
    <Container>
      <Image
        srcSet={`${getImage('form/something-wrong.png')} 1x, ${getImage('form/something-wrong@2x.png')} 2x`}
        alt="Error"
      />
      {error.code && <h1>{error.code}</h1>}
      <h2>{translations.t(error.message)}</h2>
      <ButtonWrapper>
        <CustomLink href={`/${locale}/${HELP_CENTER.MAIN}`} usePushRoute>
          <Button theme="primary" size={isTabletPortrait ? 'L' : 'S'} isMobile={deviceDetected.isMobile}>
            {translations.t('site.help.errorButton')}
          </Button>
        </CustomLink>
      </ButtonWrapper>
    </Container>
  );
};

const Container = styled.section`
  min-height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex-grow: 1;
  margin: auto;
  margin-bottom: 50px;
  padding-left: 30px;
  padding-right: 30px;
  ${paddingLevel('both', 'colar')};

  @media ${Points.tablet_portrait} {
    padding-left: 40px;
    padding-right: 40px;
  }

  main > & {
    ${marginLevel('top', 'colar')};
  }

  h1 {
    ${marginLevel('bottom', 'dark_cream')};
    ${textSize('h1')};
    text-align: center;
  }

  h2 {
    ${marginLevel('bottom', 'dark_cream')};
    ${textSize('h3')};
    text-align: center;
  }
`;

const Image = styled.img`
  display: block;
  width: 62px;
  height: 62px;
  margin: 0 auto;
  ${marginLevel('bottom', 'dark_cream')}

  @media ${Points.tablet_portrait} {
    width: 90px;
    height: 90px;
  }

  @media ${Points.laptop} {
    width: 110px;
    height: 110px;
  }
`;

const ButtonWrapper = styled.div`
  min-width: 180px;
  margin: 0 auto;

  @media ${Points.tablet_portrait} {
    min-width: 280px;
  }
`;
